export default "__VITE_ASSET__BZzX_Gtq__"